import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Box,
} from '@material-ui/core';

import { IsNoU } from 'common/utils';

import Time from './Time';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  row: {
    //height: '82px',
    display: 'flex',
    alignCompanies: 'center',
    // '& > *': {
    //   margin: theme.spacing(1),
    // },
  },
}));


const UserInfo = props => {
  const { 
    className, 
    userName,
    ...rest 
  } = props;

  const classes = useStyles();

  const [date_time, set_date_time] = useState(new Date());

  let intervalID;

  const tick = () => {
      set_date_time(new Date());
    // this.setState({
    //   date: new Date().toLocaleString()
    // });
  }

  useEffect(() => {
    //console.log("componentDidMount  ");
    intervalID = setInterval(
        () => tick(),
        1000
      );

    return () => {
        clearInterval(intervalID);
        //console.log("componentDidUnmount");
    };
  }, []);

//   useEffect(() => {
//     //console.log("componentDidMount");


//   }, [tabIndex]); // empty-array means don't watch for any updates

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
        <Box p={2}>
            <div>{userName+'님 안녕하세요.'}</div>
            <div className={classes.row}>
                {/* <Time /> */}
                {/* {'현재시간'+date_time.toLocaleString()} */}
                <h2>{date_time.toLocaleDateString()}</h2>
                &nbsp;&nbsp;
                <h2>{date_time.toLocaleTimeString()}</h2>
            </div>
        </Box>
    </Card>
  );
};

UserInfo.propTypes = {
  className: PropTypes.string,
};

UserInfo.defaultProps = {
};


export default UserInfo;
